import { InitiatorsArgs } from '../initWidgetData';
import { manageWarmupData } from '@wix/bookings-catalog-calendar-viewer-utils';
import { isEligible } from '@wix/ambassador-premium-features-manager-v1-feature/http';

const APPLICABLE_FOR_CLASSES_UNIQUE_NAME = 'bookings_groups';

export const initIsPremium = async (args: InitiatorsArgs) => {
  const { flowAPI, setState } = args;
  try {
    const response = await manageWarmupData(
      () =>
        flowAPI.httpClient.request(
          isEligible({ uniqueName: APPLICABLE_FOR_CLASSES_UNIQUE_NAME }),
        ),
      'isPremium',
      flowAPI,
    );
    setState({
      isPremium: !!response.data.isEligible,
    });
  } catch (error) {
    console.error(error);
  }
};
